function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.4 0C4.74315 0 3.4 1.34314 3.4 3V12.6C3.4 14.2569 4.74315 15.6 6.4 15.6H7.6C9.25686 15.6 10.6 14.2569 10.6 12.6V3C10.6 1.34314 9.25686 0 7.6 0H6.4ZM1.89998 10.8C1.89998 10.3029 1.49703 9.90001 0.999977 9.90001C0.502922 9.90001 0.0999756 10.3029 0.0999756 10.8C0.0999756 13.3401 0.734997 15.3782 1.97266 16.7927C3.03353 18.0051 4.46465 18.6763 6.09998 18.8526V21C6.09998 21.4971 6.50292 21.9 6.99998 21.9C7.49703 21.9 7.89998 21.4971 7.89998 21V18.8526C9.5353 18.6763 10.9664 18.0051 12.0273 16.7927C13.265 15.3782 13.9 13.3401 13.9 10.8C13.9 10.3029 13.497 9.90001 13 9.90001C12.5029 9.90001 12.1 10.3029 12.1 10.8C12.1 13.0599 11.535 14.6218 10.6727 15.6073C9.82408 16.5771 8.59071 17.1 6.99998 17.1C5.40924 17.1 4.17587 16.5771 3.3273 15.6073C2.46495 14.6218 1.89998 13.0599 1.89998 10.8Z",
  fill: "#2E7AE2"
});

var SvgMic = function SvgMic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mic.717bfcd2.svg";
export { ForwardRef as ReactComponent };